import {
  AppstoreOutlined,
  BankOutlined,
  TeamOutlined,
  SettingOutlined,
  DollarOutlined,
  GlobalOutlined,
  ApartmentOutlined,
  HomeOutlined,
  PushpinOutlined,
  IdcardOutlined,
  ThunderboltOutlined,
  BarChartOutlined,
  WalletOutlined,
  MobileOutlined
} from '@ant-design/icons';

const adminMenuItems = {
  items: [
    {
      id: 'group-admin',
      title: 'Administration',
      type: 'group',
      children: [
        {
          id: 'admin-dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/admin/dashboard',
          icon: AppstoreOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-organizations',
          title: 'Candidates',
          type: 'item',
          url: '/admin/organizations',
          icon: BankOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-users',
          title: 'Users',
          type: 'item',
          url: '/admin/users',
          icon: TeamOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-plans',
          title: 'Plans & Billing',
          type: 'item',
          url: '/admin/plans',
          icon: DollarOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-credits',
          title: 'Credits & Wallets',
          type: 'item',
          url: '/admin/credits',
          icon: WalletOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-payments',
          title: 'Payments',
          type: 'item',
          url: '/admin/payments',
          icon: MobileOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-settings',
          title: 'Settings',
          type: 'item',
          url: '/admin/settings',
          icon: SettingOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-voters',
          title: 'Voters',
          type: 'item',
          url: '/admin/voters',
          icon: IdcardOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-agent-tiers',
          title: 'Agent Tiers',
          type: 'item',
          url: '/admin/agent-tiers',
          icon: TeamOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'group-comms',
      title: 'Communications',
      type: 'group',
      children: [
        {
          id: 'admin-comm-config',
          title: 'Channel Configuration',
          type: 'item',
          url: '/admin/comm-config',
          icon: ThunderboltOutlined,
          breadcrumbs: false
        },
        {
          id: 'admin-tally',
          title: 'Live Tallying Center',
          type: 'item',
          url: '/admin/tally',
          icon: BarChartOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'group-geo',
      title: 'Electoral Geography',
      type: 'group',
      children: [
        {
          id: 'geo-counties',
          title: 'Counties',
          type: 'item',
          url: '/admin/geo/counties',
          icon: GlobalOutlined,
          breadcrumbs: false
        },
        {
          id: 'geo-constituencies',
          title: 'Constituencies',
          type: 'item',
          url: '/admin/geo/constituencies',
          icon: ApartmentOutlined,
          breadcrumbs: false
        },
        {
          id: 'geo-wards',
          title: 'Wards',
          type: 'item',
          url: '/admin/geo/wards',
          icon: HomeOutlined,
          breadcrumbs: false
        },
        {
          id: 'geo-polling-stations',
          title: 'Polling Stations',
          type: 'item',
          url: '/admin/geo/polling-stations',
          icon: PushpinOutlined,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default adminMenuItems;
